// What the UI lets a user attempt, derived from the plan limits the backend
// sends in GET /billing/me. Pure function, no React, so it can be tested.
//
// This used to be a hardcoded map keyed by plan id. Aza was added to the
// backend and not here, so a $99/mo Aza subscriber fell through to the free
// tier and found every AI button paywalled. The same map also said the free
// tier had no AI at all, while the backend grants it a one-time 10,000 words
// and the pricing page and FAQ both advertise them. Reading the backend's own
// limits means a new tier, or a changed allowance, cannot drift out of sync.
//
// The backend remains the authority: it meters words and returns 429 when an
// allowance runs out. These caps only decide what the UI offers up front.

// Used before /billing/me has loaded, or if it fails. Mirrors the free tier's
// real limits rather than locking everything, since the backend enforces anyway.
export const FALLBACK_CAPS = { canAI: true, maxNovels: 3, label: "Seer" };

export const ADMIN_CAPS = { canAI: true, maxNovels: Infinity, label: "Admin" };

export function capsFromLimits(limits) {
    if (!limits || typeof limits !== "object") return FALLBACK_CAPS;
    const max = Number(limits.max_novels);
    return {
        canAI: limits.ai === true,
        maxNovels: Number.isFinite(max) && max > 0 ? max : FALLBACK_CAPS.maxNovels,
        label: limits.label || FALLBACK_CAPS.label,
    };
}
